<template>
	<div class="prayerContainer">
        <BaseStructuredPrayerList :prayers="structuredPrayerList" v-slot="prayer">
            <PrayerPrayableDisplay :prayer="prayer" class = "prayerDiv"></PrayerPrayableDisplay>
        </BaseStructuredPrayerList>
	</div>
</template>

<script setup>

import {defineProps} from "vue";

import PrayerPrayableDisplay from "./PrayerPrayableDisplay.vue"
import {usePrayerList } from "@/composables/prayerList";
import BaseStructuredPrayerList from "./BaseStructuredPrayerList.vue";

const props = defineProps(["client"]);
const {structuredPrayerList} = usePrayerList(props.client);

</script>


<style scoped>

.prayerContainer{
	font-weight: 700;
	margin-left: auto;
	margin-right: auto;
	text-align: left;
	max-width: 90vw;
	width: 800px;

}

</style>